import { Injectable, WritableSignal, signal } from '@angular/core';
import {
  INotification,
  NotificationSystemService,
} from 'src/app/common-components/services/common-notification-system.service';
import {
  ProviderDirectoryFunctionService,
  Service,
} from 'src/app/services/providerdirectoryapi/providerdirectoryfunctionapi.services';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  private _entity: WritableSignal<Service[]> = signal<Service[]>([]);
  private _load: WritableSignal<boolean> = signal<boolean>(false);

  constructor(
    private searchService: ProviderDirectoryFunctionService,
    private notificationSystemService: NotificationSystemService
  ) {}

  async search() {
    this._load.set(true);
    this.searchService.getAllServices().subscribe({
      next: res => {
        if (res) {
          this._entity.set(res.data);
        }
        this._load.set(false);
      },
      error: error => {
        this._load.set(false);
        if (error.message) {
          const notification: INotification = { type: 'error', content: error.message };
          this.notificationSystemService.setNotification(notification);
        }
      },
    });
  }

  public fetchData() {
    if (this._entity().length === 0) {
      this.search();
    }
  }

  getServicesSignal(): WritableSignal<Service[]> {
    return this._entity;
  }

  public getLoad(): WritableSignal<boolean> {
    return this._load;
  }

  public clear(): void {
    this._entity.set(null);
  }

  public clearEntity(): void {
    this._entity.set(null);
  }

  public clearLoad(): void {
    this._load.set(null);
  }
}
